module.exports = __webpack_public_path__ + "img/cancel.e856c75c.svg";